<template>
  <div>
    <router-view />
    <div class="toast-container">
      <transition-group name="toast-fade">
        <div v-for="t in toasts" :key="t.id" class="toast-item" :class="'toast-' + t.type">
          {{ t.msg }}
        </div>
      </transition-group>
    </div>
    <div class="modal-overlay" v-if="confirmData" @click.self="confirmData=null">
      <div class="modal" style="width:400px">
        <div class="modal-hd">
          <div class="modal-title">{{ confirmData.title || '操作确认' }}</div>
          <button class="btn btn-sm" @click="confirmCancel">✕</button>
        </div>
        <div class="modal-body">
          <p style="font-size:13px;color:var(--text-2);margin:0;line-height:1.6">{{ confirmData.msg }}</p>
        </div>
        <div class="modal-ft">
          <button class="btn btn-sm" @click="confirmCancel">取消</button>
          <button class="btn btn-del btn-sm" @click="confirmOk">🗑 确认</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserColorList } from '@/api/todo'
export default {
  name: 'App',
  data() { return { toasts: [], confirmData: null, confirmResolve: null } },
  mounted() {
    this.loadUserColors()
    window.addEventListener('todo-toast', e => {
      const id = Date.now() + Math.random()
      this.toasts.push({ id, msg: e.detail.msg, type: e.detail.type || 'info' })
      setTimeout(() => { this.toasts = this.toasts.filter(t => t.id !== id) }, 4000)
    })
    window.addEventListener('todo-confirm', e => {
      this.confirmData = { title: e.detail.title, msg: e.detail.msg }
      this.confirmResolve = e.detail.resolve
    })
    window.$toast = (msg, type) => {
      window.dispatchEvent(new CustomEvent('todo-toast', { detail: { msg, type } }))
    }
    window.$confirm = (msg, title) => {
      return new Promise(resolve => {
        window.dispatchEvent(new CustomEvent('todo-confirm', { detail: { msg, title, resolve } }))
      })
    }
  },
  methods: {
    async loadUserColors() {
      const token = localStorage.getItem('todo_token')
      if (!token) return
      try {
        const res = await getUserColorList().catch(() => null)
        const data = res && res.data
        if (!data) return
        const root = document.documentElement
        if (data.hi)  root.style.setProperty('--hi', data.hi)
        if (data.md)  root.style.setProperty('--md', data.md)
        if (data.lo)  root.style.setProperty('--lo', data.lo)
        if (data.prv) root.style.setProperty('--purple', data.prv)
      } catch (e) {}
    },
    confirmOk() {
      if (this.confirmResolve) this.confirmResolve(true)
      this.confirmData = null
      this.confirmResolve = null
    },
    confirmCancel() {
      if (this.confirmResolve) this.confirmResolve(false)
      this.confirmData = null
      this.confirmResolve = null
    }
  }
}
</script>

<style>
/* ══ 全局 CSS 变量（深色主题） ══ */
:root {
  --bg:        #09111e;
  --bg-side:   #060d18;
  --bg-card:   #0f1d2e;
  --bg-card2:  #132236;
  --bg-input:  #0d192a;
  --bg-hover:  #162840;
  --border:    rgba(56,140,255,.10);
  --border-md: rgba(56,140,255,.18);
  --accent:    #38bdf8;
  --accent-d:  #0ea5e9;
  --accent-g:  rgba(56,189,248,.12);
  --purple:    #94a3b8;
  --purple-g:  color-mix(in srgb, var(--purple) 12%, transparent);
  --hi:  #f87171; --hi-g:  color-mix(in srgb, var(--hi) 15%, transparent);
  --md:  #fbbf24; --md-g:  color-mix(in srgb, var(--md) 15%, transparent);
  --lo:  #34d399; --lo-g:  color-mix(in srgb, var(--lo) 12%, transparent);
  --text:   #c8daf0;
  --text-2: #5a7a9a;
  --text-3: #2e4a65;
  --shadow: 0 8px 32px rgba(0,0,0,.45);
}

/* ══ 浅色主题 ══ */
html.light {
  --bg:        #f0f4f8;
  --bg-side:   #e4ecf5;
  --bg-card:   #ffffff;
  --bg-card2:  #f5f8fc;
  --bg-input:  #ffffff;
  --bg-hover:  #e0eaf4;
  --border:    rgba(14,90,160,.10);
  --border-md: rgba(14,90,160,.18);
  --accent:    #0284c7;
  --accent-d:  #0369a1;
  --accent-g:  rgba(2,132,199,.10);
  --purple:    #64748b;
  --purple-g:  color-mix(in srgb, var(--purple) 10%, transparent);
  --hi:  #dc2626; --hi-g:  color-mix(in srgb, var(--hi) 10%, transparent);
  --md:  #d97706; --md-g:  color-mix(in srgb, var(--md) 10%, transparent);
  --lo:  #059669; --lo-g:  color-mix(in srgb, var(--lo) 10%, transparent);
  --text:   #1e3a52;
  --text-2: #4a6a86;
  --text-3: #8aacc2;
  --shadow: 0 4px 20px rgba(0,0,0,.10);
}
html.light body { background: var(--bg); color: var(--text); }

*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
html, body { height: 100%; }
body {
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif;
  font-size: 13px; color: var(--text); background: var(--bg);
  height: 100vh; overflow: hidden;
}
button { font-family: inherit; cursor: pointer; }
a { color: var(--accent); text-decoration: none; }

/* ══ 通用按钮 ══ */
.btn {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 6px 13px; font-size: 12px; border-radius: 6px;
  cursor: pointer; border: 1px solid var(--border-md);
  background: var(--bg-card); color: var(--text);
  font-family: inherit; transition: all .15s; line-height: 1;
}
.btn:hover { background: var(--bg-hover); }
.btn-primary { background: var(--accent-d); color: #fff; border-color: var(--accent-d); }
.btn-primary:hover { background: var(--accent); color: #fff; }
.btn-accent  { background: var(--accent-g); color: var(--accent); border-color: rgba(56,189,248,.28); }
.btn-accent:hover { background: rgba(56,189,248,.20); }
.btn-ok   { background: var(--lo-g); color: var(--lo); border-color: rgba(52,211,153,.25); }
.btn-del  { background: var(--hi-g); color: var(--hi); border-color: rgba(248,113,113,.25); }
.btn-warn { background: var(--md-g); color: var(--md); border-color: rgba(251,191,36,.25); }
.btn-sm  { padding: 4px 10px; font-size: 11px; }
.btn-xs  { padding: 2px 8px;  font-size: 11px; }

/* ══ 徽章 ══ */
.bdg { display: inline-flex; align-items: center; font-size: 10px; padding: 2px 7px; border-radius: 4px; font-weight: 600; white-space: nowrap; }
.bhi  { background: var(--hi-g);  color: var(--hi);  border: 1px solid rgba(248,113,113,.3); }
.bmd  { background: var(--md-g);  color: var(--md);  border: 1px solid rgba(251,191,36,.3); }
.blo  { background: var(--lo-g);  color: var(--lo);  border: 1px solid rgba(52,211,153,.3); }
.buni { background: var(--accent-g); color: var(--accent); border: 1px solid rgba(56,189,248,.25); }
.bprv { background: var(--purple-g); color: var(--purple); border: 1px solid rgba(148,163,184,.25); }
.bok  { background: color-mix(in srgb, #10b981 12%, transparent); color: #10b981; border: 1px solid color-mix(in srgb, #10b981 25%, transparent); }
.bfail{ background: color-mix(in srgb, #ef4444 15%, transparent); color: #ef4444; border: 1px solid color-mix(in srgb, #ef4444 25%, transparent); }
.bmiss{ background: color-mix(in srgb, #f59e0b 15%, transparent); color: #f59e0b; border: 1px solid color-mix(in srgb, #f59e0b 25%, transparent); }
.bpend{ background: rgba(90,122,154,.12); color: var(--text-2); border: 1px solid var(--border); }

/* ══ 表格 ══ */
.tw { background: var(--bg-card); border: 1px solid var(--border); border-radius: 10px; overflow: hidden; }
table { width: 100%; border-collapse: collapse; font-size: 12px; }
thead tr { background: var(--bg-card2); }
th { padding: 9px 13px; text-align: left; font-weight: 700; font-size: 11px; color: var(--text-2); border-bottom: 1px solid var(--border); white-space: nowrap; }
td { padding: 9px 13px; border-bottom: 1px solid var(--border); color: var(--text); vertical-align: middle; }
tbody tr:last-child td { border-bottom: none; }
tbody tr:hover td { background: var(--bg-hover); }

/* ══ 表单 ══ */
select, input[type="text"], input[type="date"], input[type="time"], input[type="password"] {
  font-size: 12px; padding: 7px 10px; border: 1px solid var(--border-md);
  border-radius: 6px; background: var(--bg-input); color: var(--text);
  font-family: inherit; outline: none; transition: border-color .15s;
}
select:focus, input:focus { border-color: var(--accent); box-shadow: 0 0 0 2px var(--accent-g); }
select option { background: var(--bg-card2); }
textarea {
  font-size: 12px; padding: 7px 10px; border: 1px solid var(--border-md);
  border-radius: 6px; background: var(--bg-input); color: var(--text);
  font-family: inherit; outline: none; resize: vertical; min-height: 60px; width: 100%;
}
textarea:focus { border-color: var(--accent); }
.form-row { display: flex; flex-direction: column; gap: 5px; }
.form-row input:not([type='radio']):not([type='checkbox']), .form-row select, .form-row textarea { width: 100%; font-size: 12px; height: 28px; box-sizing: border-box; padding: 2px 6px; }
.form-label { font-size: 11px; color: var(--text-2); font-weight: 700; letter-spacing: .04em; }

/* ══ 模态框 ══ */
.modal-overlay {
  position: fixed; inset: 0; background: rgba(0,0,0,.65);
  display: flex; align-items: center; justify-content: center;
  z-index: 900; backdrop-filter: blur(3px);
}
.modal {
  background: var(--bg-card); border: 1px solid var(--border-md);
  border-radius: 14px; width: 580px; max-height: 88vh; overflow-y: auto;
  box-shadow: var(--shadow); animation: fadeIn .2s ease;
}
@keyframes fadeIn { from { opacity: 0; transform: scale(.97) } to { opacity: 1; transform: scale(1) } }
.modal-hd { padding: 18px 22px 14px; border-bottom: 1px solid var(--border); display: flex; align-items: center; justify-content: space-between; }
.modal-hd-actions { flex-wrap: wrap; gap: 10px; align-items: flex-start; }
.modal-actions { display: flex; gap: 8px; flex-wrap: wrap; align-items: center; justify-content: flex-end; }
.btn-close-x { min-width: 28px; padding: 4px 8px; justify-content: center; }
.modal-title { font-size: 14px; font-weight: 700; color: var(--text); display: flex; align-items: center; gap: 8px; }
.modal-body { padding: 18px 22px; }
.modal-ft { padding: 14px 22px; border-top: 1px solid var(--border); display: flex; justify-content: flex-end; gap: 8px; }
.modal-section { font-size: 11px; font-weight: 700; color: var(--text-2); letter-spacing: .06em; text-transform: uppercase; margin: 16px 0 10px; padding-bottom: 6px; border-bottom: 1px solid var(--border); }
.modal-section:first-child { margin-top: 0; }

/* ══ 滚动条 ══ */
::-webkit-scrollbar { width: 5px; height: 5px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: var(--border-md); border-radius: 3px; }

/* ══ Toast ══ */
.toast-container {
  position: fixed; top: 5%; left: 50%; transform: translateX(-50%); z-index: 1000;
  display: flex; flex-direction: column; gap: 10px; pointer-events: none;
}
.toast-item {
  min-width: 260px; max-width: 420px; padding: 10px 16px; border-radius: 10px;
  font-size: 12px; box-shadow: var(--shadow); pointer-events: all;
  text-align: center;
}
.toast-info  { background: var(--bg-card); border: 1px solid var(--border-md); color: var(--accent); }
.toast-warn  { background: var(--md-g);   border: 1px solid rgba(251,191,36,.3); color: var(--md); }
.toast-error { background: var(--hi-g);   border: 1px solid rgba(248,113,113,.3); color: var(--hi); }
.toast-fade-enter-active, .toast-fade-leave-active { transition: all .3s ease; }
.toast-fade-enter, .toast-fade-leave-to { opacity: 0; transform: translateY(-20px); }
</style>